// Variables
export const PRESSURE = 0;
export const RADIUS = 1;
export const THICKNESS = 2;
export const FORCE = 3;
export const AREA = 4;
export const STRESS = 5;

// Labels (Properties)
export const COMMENT = 0;